import { type ReactNode } from 'react';

import { ConnectivityBoundary, ConnectivityProvider } from 'src/features/connectivity';

type Props = { children: ReactNode };

/** App-shell compatibility name for the unified connectivity lifecycle and boundary. */
export default function NetworkGuard({ children }: Props) {
  return (
    <ConnectivityProvider>
      <ConnectivityBoundary>{children}</ConnectivityBoundary>
    </ConnectivityProvider>
  );
}
